import ClienteCreateQuickModal from './ClienteCreateQuickModal'

export default ClienteCreateQuickModal
